var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { paymentCardCls, paymentCardSizeSmCls, paymentCardSizeMdCls, paymentCardSizeLgCls, paymentCardVisaCls, paymentCardMasterCardCls, paymentCardVisaElectronCls, paymentCardMaestroCls, paymentCardAmexCls, paymentPayPalCls, paymentKlarnaCls, paymentCardUnknownCls } from "./Card.less";
var CARD_SIZE_CLASSNAMES = {
  small: paymentCardSizeSmCls,
  medium: paymentCardSizeMdCls,
  large: paymentCardSizeLgCls
};
var CARD_TYPE_CLASSNAMES = {
  visa: paymentCardVisaCls,
  visaelectron: paymentCardVisaElectronCls,
  visadebit: paymentCardVisaCls,
  master: paymentCardMasterCardCls,
  mastercard: paymentCardMasterCardCls,
  masterdebit: paymentCardMasterCardCls,
  maestro: paymentCardMaestroCls,
  amex: paymentCardAmexCls,
  paypal: paymentPayPalCls,
  klarna: paymentKlarnaCls,
  unknown: paymentCardUnknownCls
};
function CartPaymentCard(_ref) {
  var _ref$tagName = _ref.tagName, TagComponent = _ref$tagName === void 0 ? "span" : _ref$tagName, _ref$size = _ref.size, size = _ref$size === void 0 ? "small" : _ref$size, _ref$type = _ref.type, type = _ref$type === void 0 ? "unknown" : _ref$type, className = _ref.className, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
  return /* @__PURE__ */ React.createElement(TagComponent, {
    className: classNames(paymentCardCls, className, size && CARD_SIZE_CLASSNAMES[size], type && CARD_TYPE_CLASSNAMES[type.replace("_", "").toLowerCase()] || CARD_TYPE_CLASSNAMES.unknown)
  }, children);
}
__name(CartPaymentCard, "CartPaymentCard");
export {
  CartPaymentCard
};
